import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentforpicnicpune() {



const cardData =
{
  keyword: 'Tempo Traveller on Rent for Picnic Pune',
  heading: 'Sanavi Travels: Tempo Traveller on Rent for Picnic Pune',
  headingDescription: 'Sanavi Travels provides reliable Tempo Traveller on rent for picnic trips from Pune, ideal for family outings, corporate picnics, group tours, and leisure travel. With AC and Non-AC Tempo Travellers, experienced drivers, flexible pickup points, and transparent pricing, we ensure comfortable and well-organized picnic travel across Pune and nearby destinations.',

  top: 'Popular Picnic Travel Uses from Pune with Tempo Traveller',

  "topPlaces": [
    {
      "title": "Family Picnic Trips from Pune",
      "description": "Family picnic trips from Pune are more enjoyable when everyone travels together in a Tempo Traveller. Spacious seating, comfortable interiors, and ample luggage space allow families to relax and enjoy the journey without worrying about coordinating multiple vehicles. Children and elders benefit from a smooth ride, making the picnic experience pleasant from start to finish."
    },
    {
      "title": "Corporate Picnic & Team Outings",
      "description": "Corporate picnic travel requires punctuality, coordination, and comfort for employees. Hiring a Tempo Traveller for corporate picnics from Pune ensures teams travel together, arrive on time, and enjoy a relaxed journey. It supports better team bonding and eliminates travel-related stress for organizers."
    },
    {
      "title": "Group Picnic Travel",
      "description": "Group picnics with friends, societies, or clubs are easier with Tempo Traveller rentals. Everyone stays together, travel becomes more social, and the group reaches picnic destinations comfortably without confusion or delays."
    },
    {
      "title": "School & College Picnic Trips",
      "description": "Educational institutions prefer Tempo Travellers for picnic trips due to controlled seating, safety, and easy supervision. It ensures disciplined travel, student safety, and smooth coordination during outings."
    },
    {
      "title": "Resort & Nature Picnic Destinations",
      "description": "Picnic trips to resorts, nature parks, and countryside locations near Pune are more comfortable with Tempo Travellers, which handle longer distances and varying road conditions efficiently."
    },
    {
      "title": "Weekend Picnic Getaways",
      "description": "Weekend picnic getaways from Pune become relaxed when groups travel in a single vehicle, reducing travel fatigue and maximizing enjoyment."
    },
    {
      "title": "Society & Community Picnics",
      "description": "Housing societies and community groups rely on Tempo Travellers for organized picnic travel, ensuring everyone departs and returns together safely."
    },
    {
      "title": "Outstation Picnic Tours",
      "description": "For picnic destinations slightly outside Pune, Tempo Travellers offer stability, comfort, and cost-effective group travel solutions."
    }
  ],

  "services": [
    {
      "name": "Tempo Traveller on Rent for Picnic Pune",
      "description": "Sanavi Travels offers dedicated Tempo Traveller rental services for picnic trips from Pune, suitable for families, corporate teams, schools, and social groups. This service focuses on comfortable seating, coordinated group travel, and stress-free journeys. With professional drivers and well-maintained vehicles, picnic travel becomes safe, enjoyable, and well-organized from pickup to drop-off."
    },
    {
      "name": "AC Tempo Traveller for Picnic Pune",
      "description": "AC Tempo Travellers provide a cool and pleasant environment during picnic travel, especially in warm weather. Air-conditioned interiors help passengers remain refreshed and relaxed throughout the journey."
    },
    {
      "name": "Non AC Tempo Traveller for Picnic Pune",
      "description": "Non-AC Tempo Travellers are an economical option for picnic trips, offering comfortable seating and reliable performance for short and medium-distance travel."
    },
    {
      "name": "12 Seater Tempo Traveller Picnic Pune",
      "description": "12 seater Tempo Travellers are ideal for small family groups or friends planning intimate picnic outings with flexible travel needs."
    },
    {
      "name": "16 Seater Tempo Traveller Picnic Pune",
      "description": "16 seater Tempo Travellers balance capacity and comfort, making them suitable for medium-sized picnic groups traveling together."
    },
    {
      "name": "20 Seater Tempo Traveller Picnic Pune",
      "description": "20 seater Tempo Travellers accommodate larger groups, ensuring everyone travels comfortably in one vehicle for picnic destinations."
    },
    {
      "name": "Luxury Tempo Traveller Picnic Pune",
      "description": "Luxury Tempo Travellers offer premium interiors, pushback seating, and enhanced ride quality for high-comfort picnic travel."
    },
    {
      "name": "Tempo Traveller for Family Picnic Pune",
      "description": "Family picnic Tempo Traveller services ensure safe, coordinated, and enjoyable travel for all age groups."
    },
    {
      "name": "Tempo Traveller for Corporate Picnic Pune",
      "description": "Corporate picnic Tempo Travellers support organized employee outings with punctual service and professional travel management."
    },
    {
      "name": "Tempo Traveller for Group Picnic Pune",
      "description": "Group picnic Tempo Travellers keep everyone together, improving coordination and overall travel experience."
    },
    {
      "name": "Affordable Tempo Traveller for Picnic Pune",
      "description": "Affordable rental packages provide cost-effective picnic travel without compromising comfort or safety."
    },
    {
      "name": "Best Tempo Traveller Service Picnic Pune",
      "description": "Sanavi Travels is trusted for reliable and well-managed Tempo Traveller picnic services in Pune."
    },
    {
      "name": "Tempo Traveller with Driver Picnic Pune",
      "description": "All picnic Tempo Traveller rentals include experienced drivers familiar with Pune routes and nearby picnic spots."
    },
    {
      "name": "Tempo Traveller for Wedding Picnic Pune",
      "description": "Wedding picnic travel services ensure comfortable group movement for pre-wedding or post-wedding leisure outings."
    },
    {
      "name": "Mini Bus on Rent for Picnic Pune",
      "description": "For larger picnic groups, mini buses provide an alternative with higher seating capacity and similar comfort."
    }
  ],

  "tableData": [
    ["Tempo Traveller Picnic", "AC Tempo Traveller"],
    ["Non AC Tempo Traveller", "Luxury Tempo Traveller"],
    ["12 Seater", "16 Seater"],
    ["20 Seater", "Group Picnic"],
    ["Family Picnic", "Corporate Picnic"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable Group Travel", "WhyChoosedescription": "Ensures relaxed and enjoyable picnic journeys." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Drivers trained for city and picnic routes." },
    { "WhyChooseheading": "Multiple Seating Options", "WhyChoosedescription": "12, 16, and 20 seater Tempo Travellers available." },
    { "WhyChooseheading": "Well-Maintained Vehicles", "WhyChoosedescription": "Clean and regularly serviced fleet." },
    { "WhyChooseheading": "Flexible Pickup Points", "WhyChoosedescription": "Customizable pickup locations across Pune." },
    { "WhyChooseheading": "Affordable Pricing", "WhyChoosedescription": "Transparent and cost-effective rental packages." },
    { "WhyChooseheading": "Suitable for All Picnic Types", "WhyChoosedescription": "Family, corporate, school, and group picnics." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for reliable picnic travel services." }
  ]
};

const faqData = [
  { question: 'Do you provide Tempo Traveller for picnic trips from Pune?', answer: 'Yes, Sanavi Travels offers Tempo Traveller rentals for picnic trips from Pune.' },
  { question: 'Are AC Tempo Travellers available for picnics?', answer: 'Yes, AC and Non-AC Tempo Travellers are available.' },
  { question: 'What seating options are available?', answer: '12, 16, and 20 seater Tempo Travellers are available.' },
  { question: 'Is a driver included?', answer: 'Yes, all Tempo Traveller rentals include experienced drivers.' },
  { question: 'Can we hire Tempo Traveller for corporate picnics?', answer: 'Yes, corporate picnic travel is supported.' },
  { question: 'Are Tempo Travellers suitable for family picnics?', answer: 'Yes, they are ideal for family outings.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup points can be customized across Pune.' },
  { question: 'Are vehicles cleaned before trips?', answer: 'Yes, vehicles are cleaned and maintained regularly.' },
  { question: 'Is picnic Tempo Traveller rental affordable?', answer: 'Yes, cost-effective packages are available.' },
  { question: 'How can I book a Tempo Traveller for picnic Pune?', answer: 'You can book online or contact our customer support team.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Pawar',
    feedback: 'Very comfortable Tempo Traveller for our family picnic. Smooth and enjoyable journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'We booked a Tempo Traveller for a corporate picnic. Excellent service and coordination.',
    rating: 5
  }
];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent for Picnic Pune - Sanavi Travels",
  "description": "Sanavi Travels offers Tempo Travellers on rent in Pune for picnics, including family trips, corporate outings, group trips, and weddings. AC and Non-AC 12-seater, 16-seater, and 20-seater Tempo Travellers and mini buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Tempo Traveller on Rent for Picnic Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Travellers for picnics in Pune with Sanavi Travels. AC & Non-AC 12-seater, 16-seater, and 20-seater Tempo Travellers and mini buses for family trips, corporate outings, group trips, and weddings with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/274.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentforpicnicpune;